module.exports = __webpack_public_path__ + "pc/img/body_basic 7.a975347e.jpg";